import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-partner-with-us-for-benefits',
  templateUrl: './partner-with-us-for-benefits.component.html',
  styleUrls: ['./partner-with-us-for-benefits.component.css',
    '../../invest/home/invest.component.css', '../../../assets/styles/new-styles.css']
})
export class PartnerWithUsForBenefitsComponent {
  @Input()
  sectionColor: string;

}
